import {
  createEvent,
  createEffect,
  Store,
  Event,
  Effect,
  combine,
  createStore
} from 'effector'
import { Permission } from './permission'
import { lazyUpd } from './interview/pages/call/effector.utils'

class PermissionsService {
  readonly startPermissionsService: Event<void> = createEvent<void>()

  readonly checkPermissionFx: Effect<PermissionName, PermissionStatus, Error>

  readonly camera: Permission
  readonly microphone: Permission

  readonly $isAgreedToRecording = createStore<boolean>(false)
  readonly setAgreedToRecording = createEvent<boolean>()

  readonly $state: Store<{
    camera: PermissionState | null
    microphone: PermissionState | null
  }>

  constructor() {
    this.$isAgreedToRecording.on(this.setAgreedToRecording, lazyUpd)

    this.checkPermissionFx = createEffect(
      async (name: PermissionName): Promise<PermissionStatus> => {
        const permission = await navigator.permissions.query({ name })
        return permission
      }
    )

    this.camera = new Permission(
      'camera',
      this.checkPermissionFx,
      this.startPermissionsService
    )

    this.microphone = new Permission(
      'microphone',
      this.checkPermissionFx,
      this.startPermissionsService
    )

    this.$state = combine({
      camera: this.camera.$state,
      microphone: this.microphone.$state
    })
  }

  // private assertIsPermissionInfo(
  //   permStatus: PermissionStatus | PermissionInfo,
  //   name: PermissionName
  // ): asserts permStatus is PermissionInfo {
  //   if (permStatus.state && permStatus.name === name) return
  //
  //   throw new Error(
  //     `incorrect assertion name ${name} != permStatus.name ${permStatus.name} or not state ${permStatus.state}`
  //   )
  // }
}

export const permissionsService = new PermissionsService()
